import React from 'react';
import classNames from 'classnames';
import styles from './css/index.module.scss';
import BackButton from '../BackButton';
import QuestionHint, { QUESTION_HINT_POSITIONS } from '../../../../components/QuestionHint';
import ResultsFilters from '../ResultsFilters';
import Button from '../../../../ui-kit/Button';
import Loading from '../../../../ui-kit/Loading';
import useSoundproofing from '../../../../hooks/useSoundproofing';
import useTranslations from '../../../../hooks/useTranslations';
import { DICTIONARY } from '../../../../translations/dictionary';
import { SOUNDPROOFING_MAX_PDF_CONFIGURATIONS } from '../../../../constants/soundproofing';

function ResultsPanel({ isMobile }) {
  const { t } = useTranslations();
  const {
    resultsTotal, resultsLoading, resultsError, selectedResultsIds, pdfLoading, downloadPdf, backToComposition,
  } = useSoundproofing();

  const isEmpty = !resultsLoading && (resultsError || !resultsTotal);
  const hasSelected = selectedResultsIds.length > 0;

  const title = isEmpty
    ? t(DICTIONARY.soundproofingPage.configurationsNotFound)
    : hasSelected
      ? t(DICTIONARY.soundproofingPage.configurationsSelected, selectedResultsIds.length, resultsTotal)
      : t(DICTIONARY.soundproofingPage.configurationsFound, resultsTotal);

  const description = isEmpty
    ? ''
    : hasSelected
      ? t(DICTIONARY.soundproofingPage.saveToPdfLimit, SOUNDPROOFING_MAX_PDF_CONFIGURATIONS)
      : t(DICTIONARY.soundproofingPage.saveToPdfDescription, SOUNDPROOFING_MAX_PDF_CONFIGURATIONS);

  return (
    <div className={classNames(styles.panel, { [styles.panelMobile]: isMobile })}>
      {!isMobile && <BackButton onClick={backToComposition} />}

      <div className={classNames(styles.content, 'blueVerticalScroll')}>
        <div className={styles.card}>
          <div className={styles.countRow}>
            {resultsLoading && !resultsTotal ? (
              <div className={styles.countLoading}><Loading /></div>
            ) : (
              <>
                <p className={styles.countText}>{title}</p>
                <QuestionHint
                  text={t(DICTIONARY.soundproofingPage.configurationsCountHint)}
                  position={QUESTION_HINT_POSITIONS.bottomLeft}
                />
              </>
            )}
          </div>
          <Button
            width="100%"
            text={t(DICTIONARY.saveToPdf)}
            isDisabled={isEmpty || resultsLoading || pdfLoading}
            onClick={downloadPdf}
          />
          {description && <p className={styles.description}>{description}</p>}
        </div>

        <ResultsFilters isMobile={isMobile} />
      </div>
    </div>
  );
}

export default ResultsPanel;
